module.exports = __webpack_public_path__ + "images/directory/featured-hero/calendar.ceee689e7d59ec28ae27.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/directory/featured-hero/calendar.jpg
// module id = 11ml
// module chunks = 2